var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullyRegisteredAnalyticIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0L22.9713 3.47664L29.1246 3.46541L31.015 9.07955L36 12.538L34.0874 18.1451L36 23.7523L31.015 27.2107L29.1246 32.8248L22.9713 32.8137L18 36.2903L13.0287 32.8137L6.8754 32.8248L4.98504 27.2107L0 23.7523L1.91263 18.1451L0 12.538L4.98504 9.07955L6.8754 3.46541L13.0287 3.47664L18 0Z",
    fill: "#FFC700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.5363L15.9167 22.0726L23.75 13",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullyRegisteredAnalyticIcon);
export default __webpack_public_path__ + "static/media/FullyRegisteredAnalytic-Icon.7963e02ff3d302b28a0806426d4ba321.svg";
export { ForwardRef as ReactComponent };